module.exports = __webpack_public_path__ + "img/4.480c20f6.jpg";